export default {
  months: {
    en: 'months',
  },
  buttonTitle: {
    en: 'Buy for {price}',
  },
  save: {
    en: 'Save <strong>{saveValue}</strong> discount – <strong>{discount} Off</strong>',
  },
  plan: {
    en: '{billingPeriod} months plan<br />Just <strong>{productPrice}</strong> / product',
  },
}
